import React from "react";
import { Loader2 } from "lucide-react";
import { useCurrentPdf } from "@/views/chat/hooks/useCurrentPdf";
import { useGetFileDetailsQuery } from "@/api/files";
import { ChatInterface } from "./chat";
import { useParams } from "react-router";
import ChatLayout from "@/views/chat/layout";

const ChatWrapper = () => {
  const { systemId = "" } = useParams<{ systemId: string }>();

  const [initialFiles, setInitialFiles] = React.useState<string[] | null>(null);
  const [excludeFileIds, setExcludedFiles] = React.useState<string[]>([]);
  const { selectedFiles, setCurrentPdfId } = useCurrentPdf();

  const { data: chatContext, isLoading, error } = useGetFileDetailsQuery({ fse_id: systemId, depth: 200 });

  React.useEffect(() => {
    if (!isLoading && selectedFiles.length) {
      if (initialFiles === null) {
        setInitialFiles(selectedFiles);
        if (selectedFiles.length) {
          setCurrentPdfId(selectedFiles[0]);
        }
      } else {
        setExcludedFiles(initialFiles.filter(id => !selectedFiles.includes(id)));
      }
    }
  }, [selectedFiles, initialFiles, isLoading, setCurrentPdfId]);

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <p className="text-red-500">An error occurred while loading the chat context.</p>
      </div>
    );
  }

  if (!chatContext) {
    return null;
  }

  return (
    <div className="flex h-full w-full">
      <ChatInterface systemId={systemId} excludeFileIds={excludeFileIds} />
    </div>
  );
};

export const ChatView = () => (
  <ChatLayout>
    <ChatWrapper />
  </ChatLayout>
);
